export const ORIENTATION = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
  COLUMN: "column",
  ROW: "row",
};

export const PRINT_ORIENTATION = {
  PORTRAIT: "portrait",
  LANDSCAPE: "landscape",
};
